import React from "react";
import { useSelector } from "react-redux";
import { Menu, Nav } from "../../../shared/components/ui/menu/Menu";
import pathRouts from "../../../shared/enums/pathRoute";
import classes from "./LeftSideMenu.module.css";

const LeftSideMenu = () => {
    const { texts } = useSelector(state => state.translate);
    const { isManager } = useSelector(state => state.auth);

    return (
        <Menu className={classes.LeftSideMenu} showIcon={false}>
            {isManager && <Nav title={texts.roleHolders} to={`/${pathRouts.MANAGERDASHBOARD}/${pathRouts.ROLEHOLDERS}`} />}
            <Nav title={texts.logoAndImage} to={`/${pathRouts.MANAGERDASHBOARD}/${pathRouts.LOGOANDIMAGE}`} />
            <Nav title={texts.addEnvironments} to={`/${pathRouts.MANAGERDASHBOARD}/${pathRouts.TOOLSPAGE}`} />
            <Nav title={texts.sendSystemMessages} to={`/${pathRouts.MANAGERDASHBOARD}/${pathRouts.SYSTEMMESSAGES}`} />
        </Menu>
    );
};

export default LeftSideMenu;
